import getters from '@/store/modules/getters'
import mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

/*
mutations.D0104_OTHER_LIST = function (state, payload) {
  state.d0104OtherList = payload
}
*/
mutations.SNS_USER = function (state, payload) {
  state.sns_user = payload
}
mutations.TWITTER_TWEETS = function (state, payload) {
  state.twitterTweets = payload
}

const state = {
  rows: [],
  row: null,
  sns_user: [],
  twitterTweets: []
}
const actions = {
  init: ({ commit, state }) => {
    const ctx = {
      data: {
        // relate: { api: 'M0110SNSMetricsService.getDataForListbox' }
      }
    }

    return client.postData(ctx)
      .then((data) => {
        // commit('D0102_RELATE_LIST', data.relate.output)
      })
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0110SNSMetrics search')
    return client.postData({ data: { search: { api: 'M0110SNSMetricsService.getMetrics', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0110SNSMetrics add')
    commit('EDIT',
      {
        id: null,
        files: {},
        relates: {},
        belongs: {}
      }
    )
  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0110SNSMetrics cancel')
    commit('EDIT', null)
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0110SNSMetrics edit')
    return client.postData({ data: { find: { api: 'M0110SNSMetricsService.getData', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0110SNSMetrics delete')
    return client.postData({ data: { delete: { api: 'M0110SNSMetricsService.deleteData', input: row } } })
      .then((data) => {
        commit('EDIT', null)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0110SNSMetrics save')
    return client.postData({ data: { save: { api: 'M0110SNSMetricsService.saveData', input: row } } })
      .then((data) => {
        commit('SAVE', data.save.output)
      })
  },
  pdf: ({ commit, state }, condition) => {
    return client.download({ data: { download: { api: 'M0110SNSMetricsService.exportPdf', input: condition } } })
  },
  excel: ({ commit, state }, condition) => {
    return client.download({ data: { download: { api: 'M0110SNSMetricsService.exportExcel', input: condition } } })
  },
  csv: ({ commit, state }, condition) => {
    return client.download({ data: { download: { api: 'M0110SNSMetricsService.exportCsv', input: condition } } })
  },
  getUserNameList: ({ commit, state }, condition) => {
    console.debug('called M0110SNSMetrics search')
    return client.postData({ data: { getSNSUser: { api: 'M0101SNSAccountService.getUserNameList', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.getSNSUser.output)) {
        }
        commit('SNS_USER', data.getSNSUser.output)
      })
  },
  getTwitterTweets: ({ commit, state }, condition) => {
    console.debug('called M0110SNSMetrics getTwitterTweets')
    return client.postData({ data: { getTweets: { api: 'M0110SNSMetricsService.getTwitterTweets', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.getTweets.output)) {
        }
        commit('TWITTER_TWEETS', data.getTweets.output)
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
